import { render, staticRenderFns } from "./PendenciasClube.vue?vue&type=template&id=45c40f92"
import script from "./PendenciasClube.vue?vue&type=script&lang=ts"
export * from "./PendenciasClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports